import clsx from 'clsx';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from '../../styles/detail-header.module.css';

const WorkExportsHeader = () => {
  const [, { navigate }] = useNavigation();
  const navigateBack = (): void => {
    return navigate('/workOrders');
  };

  return (
    <div className={classes.headerContainer}>
      <IconButton onClick={navigateBack}>
        <Icon color={colors.neutral.white}>arrow_back</Icon>
      </IconButton>
      <div className={clsx(classes.nameContainer, classes.noPadding)}>
        <span>Work Export</span>
      </div>
    </div>
  );
};

export default WorkExportsHeader;
